import { render, staticRenderFns } from "./Emisiones.vue?vue&type=template&id=2ea7b816&scoped=true"
import script from "./Emisiones.vue?vue&type=script&lang=js"
export * from "./Emisiones.vue?vue&type=script&lang=js"
import style0 from "./Emisiones.vue?vue&type=style&index=0&id=2ea7b816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea7b816",
  null
  
)

export default component.exports